// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"blobStyles_wrapper__1rK7K","noShadow":"blobStyles_noShadow__3MbgI"};